import { supabase } from './supabase';
import * as cache from './cache';
import { dedup } from './dedup';

export interface HomeDashboardData {
  profile: { strength_score: number; freshness_band: string; tier: string; units: string };
  rank: { rank: number; total: number; percentile: number } | null;
  recent_workouts: { id: string; performed_at: string; payload: any }[];
  active_duels: {
    id: string; status: string; duel_type: string;
    challenger_id: string; challenged_id: string;
    timeframe_hours: number; created_at: string; end_at?: string;
  }[];
  baseline_lifts: { lift: string; logged_at: string; weight: number; reps: number }[];
  unread_coach_messages: number;
  club: { id: string; name: string; member_count: number } | null;
}

export async function fetchHomeDashboard(userId: string): Promise<HomeDashboardData | null> {
  const cacheKey = `dashboard:${userId}`;
  const cached = await cache.get<HomeDashboardData>(cacheKey);
  if (cached) return cached;

  return dedup(cacheKey, async () => {
    try {
      const { data, error } = await supabase.rpc('get_home_dashboard', { p_user_id: userId });
      if (!error && data) {
        const result = data as HomeDashboardData;
        await cache.set(cacheKey, result, 30_000);
        return result;
      }
    } catch {
      // fall through
    }
    return null;
  });
}
